import { Component, OnInit } from '@angular/core';
import { BackdropService } from 'src/app/services/backdrop/backdrop.service';
import { SaveDialogService } from 'src/app/services/save-dialog/save-dialog.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';
import { QuestionnaireService } from 'src/app/services/questionnaire/questionnaire.service';
import { BuilderService } from 'src/app/services/builder/builder.service';
import constants from 'src/app/shared/constants';

@Component({
    selector: 'xqnr-save-dialog',
    templateUrl: './save-dialog.component.pug',
    styleUrls: ['./save-dialog.component.scss'],
    animations: [
        trigger('showHide', [
            transition(':enter', []),
            transition(':leave', [])
        ])
    ],
    standalone: false
})
export class SaveDialogComponent implements OnInit {
  emailSent = false;

  constructor(
    public saveDialog: SaveDialogService,
    private backdrop: BackdropService,
    private auth: AuthService,
    private router: Router,
    private qs: QuestionnaireService,
    private builder: BuilderService
  ) {}

  ngOnInit() {
    this.backdrop.active$.subscribe((activeState: boolean) => {
      if (!activeState) this.saveDialog.hide();
    });
  }

  hideSaveDialog() {
    this.saveDialog.hide();
    this.backdrop.hide();
  }

  connectXrefAccount() {
    // Make sure user does not have to click "save" twice
    this.builder.setAutoSaveOnOauthReturn();

    this.auth.authoriseOauthConnection();
  }

  handleEmailSubmit() {
    this.emailSent = true;
  }

  saveQuestionnaireSuccess = () => {
    this.hideSaveDialog();
    this.router.navigate([`/${constants.APP_ROUTE_PATHS.sentToEmail}`]);
  };

  saveQuestionnaireError = (err: any) => {
    console.error(err);
  };

  assignUserSuccess = (res: any) => {
    let qId = this.builder.questionnaire.id;

    // Saving a questionnaire created by another user,
    // The questionnaire must be cloned and user saves the new cloned questionnaire
    if (res.cloned)
      qId = res.id;

    this.qs.sendQuestionnaireToEmail(qId).subscribe(
      this.saveQuestionnaireSuccess,
      this.saveQuestionnaireError
    );
  };

  assignUserError = (res: any) => {
    console.error(res);
  };

  handleCodeSubmit() {
    this.qs.assignUserToQuestionnaireImplicit(
      this.builder.questionnaire.id
    ).subscribe(
      this.assignUserSuccess,
      this.assignUserError
    );
  }

  handleResendCode() {
    this.emailSent = false;
  }
}
